import { z } from "zod";
import { BaseConfigurationsOutputItemWithColorSchema } from "./BaseConfigurationsOutputItem";

export const ConfigurationsProcessingOutputSchema = z.object({
    items: z.array(BaseConfigurationsOutputItemWithColorSchema),
});

export type ConfigurationsProcessingOutput = z.infer<typeof ConfigurationsProcessingOutputSchema>;